export const FETCH_AUCTION_ORDERS_BASE_UI_PATH = ['FETCH_AUCTION_ORDERS'];
